const SvgIconTriangle = (props) => {
  const {
    width = 10,
    height = 6,
    enableViewBox = true,
    iconFillColor = "#000000",
    strokeColor = "transparent",
    ...otherProps
  } = props;
  return (
    <svg
      width={width}
      height={height}
      {...(enableViewBox && { viewBox: `0 0 ${width} ${height}` })}
      {...otherProps}
    >
      <g fill={iconFillColor}>
        <polygon
          points="0,0 32,0 16,24"
          points={`0,0 ${width},0 ${width / 2},${height}`}
          stroke={strokeColor}
          strokeWidth="2"
        />
      </g>
    </svg>
  );
};

export default SvgIconTriangle;
